
class ServiceFailErreur {

  getErreur = (error) => {
    if (error === null || error === undefined) return "";
    if (error.response === null || error.response === undefined) {
      return (error.message = !null ? error.message : error + "");
    }
    if (error.response.data === null || error.response.data === undefined) {
      return (error.response.message = !null ? error.response.message : error.response + "")
    }
    if (error.response.data.message === null || error.response.data.message === undefined) {
      return (error.response.data)
    }
    if (error.response.data.message != null || error.response.data.message != undefined) {
      return (error.response.data.message)
    }
    return "Erreur undefined !"
  }

  invalidTokenRequered(error) {
    if (error === null || error === undefined) return false;
    if (error.response === null || error.response === undefined) {
      return false;
    }
    if (error.response.data === null || error.response.data === undefined) {
      return false;
    }
    if (error.response.data.code === null || error.response.data.code === undefined) {
      return false;
    }
    if (error.response.data.code != null || error.response.data.code != undefined) {
      return(error.response.data.code === 401);
    }
    return false;
  }



}

export default new ServiceFailErreur();
